//@flow
import * as actionTypes from './actionTypes';
import reduce from '../reduce';
import type { ReducerState$Type,Action$Type } from '../genericFlowTypes'

const initialState:ReducerState$Type = {
    error: '',
    invoiceSubmitted: false,
    resultset: null,
    anyChanges: false,
    formData: {},
    reviewQuestions: [],
    formError: {},
    vendors: [],
    vendorsLoaded: false,
    resultsetId: null,//line item
    lineItems: [],//line item
    count: 0,//line item
    page: 1,//line item
    pageSize: 5,//line item
    pages: 0,//line item
    sortField: 'item_row_index',//line item
    sortOrder: 'asc',//line item
    totalSumOfItemAmount: 0,//line item
    lineItem: null,//line item
    lineItemId: null,//line item
    addEditLineItem: false
}

//In use : actionTypes.HARMONIA_INV_SUBMIT_SUCCESS
const invoiceSubmittedSuccess = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: true,
        error: ''
    }
}

//actionTypes.INV_SUBMITTED_COMPLETED
const invSubmittedCompleted = (state:ReducerState$Type) => {
    return {
        ...state,
        invoiceSubmitted: false
    }
}

const editVerifyFormDataSuccess=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: '',
        formData: action.formData,
        reviewQuestions: action.reviewQuestions
    }
}

const updateFormError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        formError: action.formError
    }
}

const refreshedVendors=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        vendors: action.vendors,
        vendorsLoaded: true
    }
}

const headerActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const receivedLineItems=(state:ReducerState$Type,action:Action$Type)=>{
    const { lineItems,count,page,pageSize,pages,sortField,sortOrder,resultsetId,taskAcceptedInfoId,totalSumOfItemAmount,search } = (action.data:any);
    return {
        ...state,
        lineItems: lineItems,
        count: count,
        page: page,
        pageSize: pageSize,
        pages: pages,
        sortField: sortField,
        sortOrder: sortOrder,
        anyChanges: false,
        resultsetId: resultsetId,
        taskAcceptedInfoId: taskAcceptedInfoId,
        totalSumOfItemAmount: totalSumOfItemAmount,
        search: search,
        error: ''
    }
}

const addNewLineItem = (state:ReducerState$Type) => {
    return {
        ...state,
        addEditLineItem: true,
        lineItem: null
    }
}

const cancelAddNewLineItem = (state:ReducerState$Type)=>{
    return {
        ...state,
        addEditLineItem: false
    }
}

const newLineItemCreated=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        addEditLineItem: false
    }
}

const editLineItem=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        addEditLineItem: true,
        lineItem: action.lineItem
    }
}

const lineItemUpdated=(state:ReducerState$Type)=>{
    return {
        ...state,
        addEditLineItem: false,
        lineItem: null
    }
}

const lineItemActionsSuccess=(state:ReducerState$Type)=>{
    return {
        ...state,
        anyChanges: true,
        error: ''
    }
}

const lineItemActionsError=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        error: action.error
    }
}

const lineItemSelectedId=(state:ReducerState$Type,action:Action$Type)=>{
    return {
        ...state,
        lineItemId: action.lineItemId
    }
}

export default reduce(initialState,{
    [actionTypes.HARMONIA_INV_SUBMITTED_COMPLETED]: invSubmittedCompleted,
    [actionTypes.HARMONIA_INV_SUBMIT_SUCCESS]: invoiceSubmittedSuccess,
    [actionTypes.HARMONIA_INV_SUBMIT_ERROR]: headerActionsError,
    [actionTypes.HARMONIA_EDIT_VERIFY_FORM_DATA_SUCCESS]: editVerifyFormDataSuccess,
    [actionTypes.HARMONIA_EDIT_VERIFY_FORM_DATA_ERROR]: headerActionsError,
    [actionTypes.HARMONIA_UPDATE_FORM_ERROR]: updateFormError,
    [actionTypes.REFRESH_HARMONIA_VENDORS_SUCCESS]: refreshedVendors,
    [actionTypes.REFRESH_HARMONIA_VENDORS_ERROR]: headerActionsError,
    [actionTypes.GET_HARMONIA_ITEMS_SUCCESS]: receivedLineItems,
    [actionTypes.GET_HARMONIA_ITEMS_ERROR]:lineItemActionsError,
    [actionTypes.OPEN_ADD_EDIT_LINEITEM_FORM]:addNewLineItem,
    [actionTypes.CANCEL_ADD_EDIT_LINEITEN_FORM]:cancelAddNewLineItem,
    [actionTypes.CREATE_NEW_HARMONIA_ITEM_SUCCESS]:newLineItemCreated,
    [actionTypes.CREATE_NEW_HARMONIA_ITEM_ERROR]:lineItemActionsError,
    [actionTypes.EDIT_HARMONIA_ITEM]:editLineItem,
    [actionTypes.UPDATE_HARMONIA_ITEM_SUCCESS]:lineItemUpdated,
    [actionTypes.UPDATE_HARMONIA_ITEM_ERROR]:lineItemActionsError,
    [actionTypes.MOVE_DOWN_HARMONIA_ITEM_SUCCESS]:lineItemActionsSuccess,
    [actionTypes.MOVE_DOWN_HARMONIA_ITEM_ERROR]:lineItemActionsError,
    [actionTypes.MOVE_UP_HARMONIA_ITEM_SUCCESS]:lineItemActionsSuccess,
    [actionTypes.MOVE_UP_HARMONIA_ITEM_ERROR]:lineItemActionsError,
    [actionTypes.DELETE_HARMONIA_ITEM_SUCCESS]:lineItemActionsSuccess,
    [actionTypes.DELETE_HARMONIA_ITEM_ERROR]:lineItemActionsError,
    [actionTypes.SELECTED_HARMONIA_ITEM_ID]:lineItemSelectedId
});


// WEBPACK FOOTER //
// ./src/redux/harmonia/reducer.js